import {useState, useEffect} from "react";
import IconButton from "@mui/material/IconButton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import ListItemText from "@mui/material/ListItemText";
import ListItem from "@mui/material/ListItem";
import Slider from "@mui/material/Slider";
import Box from "@mui/material/Box";

const LayerMenuLegendItem = ({
    icon = null,
    text = null,
    toggleFn = null,
    opacityFn = null,
    opacityControl = null,
}) => {
    const [visible, setVisible] = useState(true);
    const [opacity, setOpacity] = useState(opacityControl);

    useEffect(() => {
        if (toggleFn != null) {
            toggleFn(visible);
        }
    }, [visible]);

    useEffect(() => {
        if (opacityControl != null && opacityFn != null) {
            opacityFn(opacity); // Convert percentage to decimal (0-1)
        }
    }, [opacityControl, opacityFn, opacity]);

    const handleOpacityChange = (event, newValue) => {
        setOpacity(newValue);
    };

    return (
        <ListItem disablePadding className="LayerMenuLegendItem" sx={{display: "flex"}}>
            {/* Left content container - adapts to remaining space */}
            <Box sx={{display: "flex", alignItems: "center", flex: 1, minWidth: 0}}>
                {toggleFn && (
                    <IconButton
                        onClick={() => {
                            setVisible(!visible);
                        }}
                        className="LayerMenuLegendItemButton"
                    >
                        {visible ? <VisibilityIcon /> : <VisibilityOffIcon />}
                    </IconButton>
                )}
                {icon && <div className="LayerMenuLegendItemIcon">{icon}</div>}
                {text && (
                    <ListItemText primary={text} className="LayerMenuLegendItemText" />
                )}
            </Box>

            {/* Right content container - fixed width for slider */}
            {opacityControl && (
                <Box
                    sx={{
                        width: 80,
                        pl: 1,
                        pr: 2,
                        display: "flex",
                        alignItems: "center",
                    }}
                >
                    <Slider
                        size="small"
                        value={opacity}
                        onChange={handleOpacityChange}
                        aria-label="Opacity"
                        valueLabelDisplay="off"
                        min={0}
                        max={1}
                        step={0.1}
                        disabled={!visible}
                    />
                </Box>
            )}
        </ListItem>
    );
};

export default LayerMenuLegendItem;
